import checkFSKExist from "./checkFSKExist"

const getFSKString = (fsk, fskString = 'FSK', fskStringUnknown = "unbekannt") => {
    if(checkFSKExist(fsk)) {
        return `${fskString} ${fsk}`
    } else {
        return `${fskString} ${fskStringUnknown}`
    }
}

export default getFSKString